import * as React from 'react';
import { cn } from '../lib/cn.ts';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  'data-testid'?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-9 w-full rounded-md border border-[var(--color-input)]',
          'bg-[var(--color-alabaster)] px-3 py-2',
          'font-[var(--font-text)] text-sm text-[var(--color-charcoal)]',
          'placeholder:text-[var(--color-stone-mid)]',
          'transition-colors',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-ring)] focus-visible:ring-offset-0 focus-visible:border-[var(--color-warm-stone)]',
          'disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-[var(--color-stone-100)]',
          'file:border-0 file:bg-transparent file:text-sm file:font-medium',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
